import request from '../helpers'

const state = {
  loading: false,
  address: {},
  addresses: []
}

const mutations = {
  CHANGE_LOADING_STATE(state, loading) {
    state.loading = loading
  },
  SET_ADDRESS (state, station) {
    if (station != null) {
      state.address = Object.assign({}, station)
    } else {
      state.address = {}
    }
  },
  UPDATE_ADDRESSES (state, stations) {
    state.addresses = stations
  },
  APPEND_UPDATE_ADDRESS (state, station) {
    var currentIndex = state.addresses.findIndex(u => u.id == station.id)
    if (currentIndex == -1)
      state.addresses.push(station)
    else
      state.addresses.splice(currentIndex, 1, station) // necessary to force vue to detect the change
    if (state.address.id == station.id)
      state.address = station;
  },
  DELETE_ADDRESS (state, station) {
    var currentIndex = state.addresses.findIndex(c => c.id == station.id)
      if (currentIndex != -1)
        state.addresses.splice(currentIndex, 1)
  }
}

const actions = {
  getAddresses({ commit }) {
    return request({ commit: commit, method: 'get', url: 'deliveryAddress/list', successCallback: addresses => {
      commit('UPDATE_ADDRESSES', addresses);
    }});
  },
  
  saveAddress({ commit }, data) {
    return request({ commit: commit, method: 'post', url: 'deliveryAddress', data: data, successCallback: address => {
      commit('APPEND_UPDATE_ADDRESS', address);
    }});
  },
  deleteAddress({ commit }, data) {
    return request({ commit: commit, method: 'delete', url: `deliveryAddress/${data.id}`, successCallback: address  => {
      commit('DELETE_ADDRESS', address);
    }});
  }
}

const getters = {
  allowDelete(state) {
    return state.addresses.length > 1
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
